'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable');
module.exports = function NetworkStatusDispatcher(config, navigatorModel) {
	let currentStatus,
		currentOnline,
		currentlySaving,
		wasSaving,
		currentDelay;
	const self = observable(this),

		calcStatus = function () {
			if (!currentOnline) {
				return 'offline';
			}
			if (!currentDelay && !currentlySaving) {
				return 'passive';
			}
			if (currentDelay > config.delayWarning) {
				return 'delayed';
			}
			return 'active';
		},
		notifyListeners = function () {
			const newStatus = calcStatus();
			if (currentStatus !== newStatus) {
				currentStatus = newStatus;
				self.dispatchEvent('statusChanged', currentStatus);
			}
		},
		onNetworkStatusChange = function (isOnline) {
			currentOnline = isOnline;
			notifyListeners();
		};
	self.notifySavingChanged = function (isSaving) {
		currentlySaving = isSaving;
		wasSaving = wasSaving || isSaving;
		notifyListeners();
	};
	self.notifySaveDelay = function (saveDelay) {
		currentDelay = saveDelay;
		if (wasSaving || saveDelay) {
			notifyListeners();
		}
	};
	self.notifyDocumentClosed = function () {
		onNetworkStatusChange(false);
	};
	navigatorModel.addEventListener('network-status', onNetworkStatusChange);
	currentOnline = navigatorModel.isOnline();
};
